import React, { FC } from 'react';

import { KycStatus, kycStatus$ } from '../../api/kycStatus/kycStatus';
import { isWalletSetuped$ } from '../../api/wallet/wallet';
import { useIdoInfo } from '../../common/hooks/useIdoInfo';
import { useObservable } from '../../common/hooks/useObservable';
import { RoundFormState } from './common/types/roundFormState';
import { ConnectWalletState } from './ConnectWalletState/ConnectWalletState';
import { Contribution } from './ContributionState/Contribution';
import { ErrorState } from './ErrorState/ErrorState';
import { KycState } from './KycState/KycState';
import { WhitelistingState } from './WhitelistingState/WhitelistingState';

export const RoundForm: FC = () => {
  const { currentRound } = useIdoInfo();
  const [isWalletConnected] = useObservable(isWalletSetuped$);
  const [kycStatus] = useObservable(kycStatus$);

  let state: RoundFormState = RoundFormState.EMPTY;

  if (!isWalletConnected) {
    state = RoundFormState.CONNECT_WALLET;
  } else if (
    kycStatus !== KycStatus.PASSED &&
    kycStatus !== KycStatus.LOADING &&
    currentRound?.activeSubround === 'contribution'
  ) {
    state = RoundFormState.ERROR;
  } else if (kycStatus !== KycStatus.PASSED) {
    state = RoundFormState.KYC;
  } else if (currentRound?.activeSubround === 'whitelist') {
    state = RoundFormState.WHITELISTING;
  } else if (currentRound?.activeSubround === 'contribution') {
    state = RoundFormState.CONTRIBUTION;
  }

  return (
    <>
      {state === RoundFormState.CONNECT_WALLET && <ConnectWalletState />}
      {state === RoundFormState.ERROR && <ErrorState />}
      {state === RoundFormState.KYC && <KycState kycStatus={kycStatus!} />}
      {state === RoundFormState.WHITELISTING && (
        <WhitelistingState currentRound={currentRound!} />
      )}
      {state === RoundFormState.CONTRIBUTION && (
        <Contribution key="contribution" />
      )}
    </>
  );
};
